<p
  class="error-message"
  *ngIf="oversubscriptionAmount() > 0"
>
  The amount exceeds the total being raised by
  {{ symbol }}{{ oversubscriptionAmount() | number }}
</p>
